import { render } from "./DetailEmployeePage.vue?vue&type=template&id=3a06807a&scoped=true"
import script from "./DetailEmployeePage.vue?vue&type=script&lang=js"
export * from "./DetailEmployeePage.vue?vue&type=script&lang=js"

import "./DetailEmployeePage.vue?vue&type=style&index=0&id=3a06807a&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a06807a"]])

export default __exports__